var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEditIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "edit-icon-svg",
    d: "M9.53977 6.78261C9.93091 6.39208 9.93104 5.7583 9.54007 5.3676L8.23336 4.06183C7.84298 3.67173 7.21036 3.67163 6.81986 4.06163L0.293596 10.5795C0.105779 10.767 0.000244141 11.0216 0.000244141 11.287V12.592C0.000244141 13.1443 0.44796 13.592 1.00024 13.592H2.30605C2.571 13.592 2.82512 13.4869 3.01261 13.2997L9.53977 6.78261ZM10.1772 0.707106C10.5678 0.316582 11.2009 0.316582 11.5915 0.707106L12.8968 2.01246C13.2873 2.40298 13.2873 3.03615 12.8968 3.42667L12.2354 4.08812C11.8448 4.47865 11.2117 4.47865 10.8211 4.08812L9.51579 2.78277C9.12527 2.39225 9.12527 1.75908 9.51579 1.36856L10.1772 0.707106Z",
    fill: "#9D9ABA"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/editIcon.e8f3b2c6.svg";
export { ForwardRef as ReactComponent };